






























































import {DAP_ROUTES} from '@/modules/dap/router';
import {REPORT_ROUTES} from '@/modules/neodash/router';
import {FILTERS_RESET} from '@/modules/neodash/store/modules/filters/types';
import {REPORT_RESET} from '@/modules/neodash/store/modules/report/types';
import {i18nService, stringService, traceLogAccess} from '@/services';
import _ from 'lodash';
import {debounceTime, distinctUntilChanged, pluck, startWith} from 'rxjs/operators';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {
  basicCardReport,
  cardInfo,
  cardReportWithSubKey,
  lstCards,
  refactoredCardInfo,
  reportContextEnum,
  reportTypeEnum
} from '@/modules/neodash/model/constants/cards';
import {RawLocation} from 'vue-router';
import {LIST_REPORTS} from '@/modules/neodash/store/modules/reports/types';
import {Report} from '@/modules/neodash/model/types/interfaces/Report';
import {BPA_ROUTES} from '@/modules/business-plan/router';
import {PageContextName} from '@/enums';
import {ContextEnum} from '@/enums/context.enum';

@Component({
    subscriptions() {
      return {
        searchValue$: this.$watchAsObservable('searchInput').pipe(
            pluck('newValue'),
            debounceTime(400),
            distinctUntilChanged(),
            startWith('')
        )
      };
    }
  })
  export default class ReportCenter extends Vue {
    public cards: Array<cardInfo> = [];
    public searchInput: string = '';
    public searchValue$: string;
    public filtersViewVisible: boolean = true;
    public noResultsFound: boolean = false;
    public translate = i18nService.i18n;

    @Action(FILTERS_RESET)
    resetFilters: Function;

    @Action(REPORT_RESET)
    resetReport: Function;

    @Getter(LIST_REPORTS)
    listReports: Report[];

    @Watch('listReports')
    public updateListCards(): void {
      const {listReports} = this;
      if (!listReports)
        return;

      this.cards = lstCards.filter(x => listReports.some(z => z.id === x.reportId));
    }

    public cardsSortedBy(property = 'reportName') {
      return (
          _(this.cards)
              .filter(r =>
                  _.size(this.searchValue$)
                      ? stringService.normalize(this.translate(r.reportName)).includes(stringService.normalize(this.searchValue$))
                      : true
              )
              .orderBy(r =>
                  _.size(this.searchValue$) ? stringService.normalize(this.translate(r.reportName)) : stringService.normalize(this.translate(r[property]))
              )
              .groupBy(r => r.reportContext)
              .map(r => _.chunk(r, 4))
              .value()
      );
    }

    public getLabelContext(ctx: reportContextEnum): string {
      const labels: { ctx: reportContextEnum, label: string }[] = [
        {ctx: reportContextEnum.drd, label: 'DRD - Desenvolvimento de Rede'},
        {ctx: reportContextEnum.directSale, label: 'Venda Direta'},
        {ctx: reportContextEnum.distribution, label: 'Distribuição'},
        {ctx: reportContextEnum.afterSales, label: 'Pós-Vendas'},
      ];

      if (!labels.some(x => x.ctx === ctx))
        throw new Error('Context not found, please register on report-center.page.vue');

      return labels.findOrFirst(x => x.ctx === ctx).label;
    }

    public getIconType(type: reportTypeEnum) {
      const types: { type: reportTypeEnum, icon: string }[] = [
        {type: reportTypeEnum.reportViewer, icon: 'bar chart'},
        {type: reportTypeEnum.reportPage, icon: 'table'},
      ];

      const result = types.find(x => x.type === type);
      return !!result ? result.icon : 'file';
    }

    public changeRoute(report: cardInfo) {
      traceLogAccess.logAction(ContextEnum.Report, this.translate(report.reportName), 'Acesso');

      const routes: { type: reportTypeEnum, route: RawLocation }[] = [
        // {
        //   type: reportTypeEnum.refactoredCard,
        //   route: {
        //     name:REPORT_ROUTES.REPORT_POWERBI_PAGE,
        //     params: { reportName: (report as basicCardReport).reportKey }
        //   }
        // },
        {
          type: reportTypeEnum.reportViewer,
          route: {
            name: REPORT_ROUTES.WORKBOOK_PAGE,
            params: {
              workbook: (report as cardReportWithSubKey).reportKey,
              worksheet: (report as cardReportWithSubKey).reportSubKey
            }
          }
        },
        {
          type: reportTypeEnum.reportPage,
          route: {
            name: REPORT_ROUTES.REPORT_PAGE,
            params: {reportName: (report as basicCardReport).reportKey}
          }
        },
        {
          type: reportTypeEnum.dapEmptyProject,
          route: {name: DAP_ROUTES.PROJECT_EMPTY}
        },
        {
          type: reportTypeEnum.dapSubmittedProjects,
          route: {name: BPA_ROUTES.HOME}
        },
        {
          type: reportTypeEnum.dapSubmittedProjectsRetail,
          route: {name: DAP_ROUTES.SUBMITTED_PROJECTS_RETAIL}
        },
        {
          type: reportTypeEnum.refactoredCard,
          route: {name: (report as refactoredCardInfo).reportKey}
        },
        {
          type: reportTypeEnum.businessPlanApproval,
          route: {name: BPA_ROUTES.HOME}
        }
      ];
      const routeObject = routes.find(x => x.type === report.reportType);
      if (!routeObject)
        throw new Error(`Report type not registered (${report.reportType}) please register on report-center.page.vue`);

      this.$router.push(routeObject.route);
    }

    public created() {
      this.resetFilters();
      this.resetReport();
      this.updateListCards();
    }
  }
